// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || 'https://c0f27488cbb240a7b5c8311746356237@o561137.ingest.sentry.io/6253054',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.1,
  environment: process.env.SENTRY_ENVIRONMENT,
  allowUrls: [
    /localhost/,
    /develop7.collegerecruiter.com/,
    /staging7.collegerecruiter.com/,
    /collegerecruiter.com/
  ],
  denyUrls: [
    /cdn.pardot/,
    /connect.facebook/,
    /googletagmanager.com/,
    /maps.googleapis.com/,
    /google-analytics.com/,
    /extensions\//i,
    /^chrome:\/\//i
  ]
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
